import { useTranslation } from 'react-i18next';

export default function OurChannel() {
  const { t } = useTranslation();
  const channels = [
    { title: t('channel.team'), image: 'https://readdy.ai/api/search-image?query=Travel%20team%20group%20photo%20Vietnam%20tour%20company%20staff%20happy%20professional%20uniform%20office%20environment%20warm%20lighting&width=300&height=200&seq=channel-1&orientation=landscape' },
    { title: t('channel.guide'), image: 'https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20tour%20guide%20explaining%20history%20to%20tourists%20ancient%20temple%20background%20passionate%20storytelling%20travel%20experience&width=300&height=200&seq=channel-2&orientation=landscape' },
    { title: t('channel.internet'), image: 'https://readdy.ai/api/search-image?query=Split%20concept%20comparison%20internet%20travel%20information%20versus%20local%20expert%20knowledge%20creative%20illustration%20travel%20planning&width=300&height=200&seq=channel-3&orientation=landscape' },
    { title: t('channel.expert'), image: 'https://readdy.ai/api/search-image?query=Traveler%20consulting%20with%20local%20Vietnamese%20expert%20planning%20trip%20map%20table%20friendly%20conversation%20personalized%20service&width=300&height=200&seq=channel-4&orientation=landscape' },
    { title: t('channel.essentials'), image: 'https://readdy.ai/api/search-image?query=Travel%20essentials%20flat%20lay%20passport%20camera%20sunglasses%20hat%20map%20backpack%20Vietnam%20travel%20preparation%20aesthetic%20photography&width=300&height=200&seq=channel-5&orientation=landscape' },
  ];

  return (
    <section className="w-full bg-primary-100 py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-2">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-secondary-900">{t('channel.title')}</h2>
            <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
              <i className="ri-youtube-fill text-white text-xs" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {channels.map((channel) => (
            <a
              key={channel.title}
              href="#"
              className="group relative aspect-[3/2] rounded-xl overflow-hidden"
            >
              <img
                src={channel.image}
                alt={channel.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-3 left-3 right-3">
                <p className="text-white text-sm font-medium">{channel.title}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}